Promise.all([
  import(/* webpackMode: "eager" */ './deals-widget.scss'),
  import('../../scripts/dbs/dbs.utilities.geolocation'),
  import('../../plugins/semantic/modal.scss'),
  import('../../plugins/semantic/modal'),
  import('../../plugins/semantic/dimmer.scss'),
  import('../../plugins/semantic/dimmer'),
  import('../../plugins/semantic/loader.css'),
]).then(() => {
  $('.widget.deals-widget').each(function (i, el) {
    $(el).data('widget', new DealsWidget(el))
    $(el).data('widget').init()
  })
})

function DealsWidget(el) {
  const self = this
  self.el = $(el)
  self.deals = require('./deals.hbs')
  self.latitude = null
  self.longitude = null

  self.showDeals = function (location, offset) {
    const delimitedCategories = self.el.attr('data-categories')
    const count = self.el.attr('data-loadlimit')
    const displayType = self.el.attr('data-display-type')

    let apiUrl = $(el).attr('data-endpoint-nearby')

    if (location.indexOf('statetab') != -1) {
      apiUrl = $(el).attr('data-endpoint-state')
    }

    $.ajax({
      url: apiUrl,
      type: $(el).attr('data-method'),
      data: JSON.stringify({
        displaytype: displayType,
        categories: delimitedCategories,
        location: location,
        offset: offset,
        count: count,
        latitude: self.latitude,
        longitude: self.longitude,
      }),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        // switch tab from nearby to featured
        if (data.Location.toLowerCase() === 'nearby') {
          self.el.find('.switchable').html('Nearby')
        }
        if (data.Location.toLowerCase() === 'featured') {
          self.el.find('.switchable').html('Featured')
        }

        // decide what tab to render results in
        let tab = data.Location.toLowerCase()
        if (data.Location.toLowerCase() === 'nearby' || data.Location.toLowerCase() === 'featured') {
          tab = 'firsttab'
        }

        self.el.find('.deal-container[data-deal="' + tab + '"] .load-more').removeClass('loading')
        // $.fn.matchHeight._update();

        if (data.Deals != null && data.Deals.length) {
          const html = self.deals(data)

          if (self.el.find('.tab[data-deal="' + tab + '"]').hasClass('loaded')) {
            self.el.find('.deal-container[data-deal="' + tab + '"] .deals').append(html)
          } else {
            self.el.find('.deal-container[data-deal="' + tab + '"] .deals').html(html)
          }

          // load more
          if (parseInt(data.TotalCount) > parseInt(data.Offset) + parseInt(data.PageSize)) {
            self.el.find('.deal-container[data-deal="' + tab + '"] .button-container').show()
          } else {
            self.el.find('.deal-container[data-deal="' + tab + '"] .button-container').hide()
          }

          // update offset
          const newOffset = parseInt(data.Offset) + parseInt(data.PageSize)
          self.el.find('.tab[data-deal="' + tab + '"]').attr('data-offset', newOffset)
          // self.el.find('.main-container').matchHeight();
          // $.fn.matchHeight._update();
        } else {
          if (data.Message && data.Message.length) {
            $('<div class="message">' + data.Message + '</div>').insertBefore(
              self.el.find('.deal-container[data-deal="' + tab + '"] .deals'),
            )
            self.el.find('.deal-container[data-deal="' + tab + '"] .deals .loader').removeClass('active')
          } else {
            self.el.find('.deal-container[data-deal="' + tab + '"] .message').remove()
          }
          // $.fn.matchHeight._update();
        }

        self.el.find('.tab[data-deal="' + tab + '"]').addClass('loaded')
        // $.fn.matchHeight._update();
      })
      .fail(function () {
        // TODO decide what happens on fail
      })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('DealsWidget init', self)
    }

    self.geo = new dbs.utilities.geolocation()
    self.geo.events.subscribe('Geolocation:getPosition_error', function () {
      self.showDeals(firsttab, 0)
    })
    self.geo.events.subscribe('Geolocation:getPosition_response', function (response) {
      self.latitude = response.coords.latitude
      self.longitude = response.coords.longitude
      self.showDeals(firsttab, 0)
    })
    self.geo.getPosition()

    self.el.css('opacity', 1)
    self.termsModal = self.el.find('.terms-popup').modal()

    const firsttab = self.el.find('.tab:first').attr('data-deal')

    $('body').on('click', '.deals-widget .deals .deal .terms .expander', function (e) {
      e.preventDefault()
      self.termsModal.find('.content').html($(this).siblings('.content').html())
      self.termsModal.modal('show')
    })

    self.el.find('.tabs .tab').click(function (event) {
      event.preventDefault()
      $(this).addClass('active').siblings().removeClass('active')
      self.el.find('.deal-container').removeClass('active')
      self.el.find('.deal-container[data-deal="' + $(this).attr('data-deal') + '"]').addClass('active')

      if (!$(this).hasClass('loaded')) {
        let offset = 0
        if ($(this).attr('data-offset')) {
          offset = parseInt($(this).attr('data-offset'))
        }
        self.showDeals($(this).attr('data-deal'), offset)
      }

      // setTimeout(function(){
      //   $.fn.matchHeight._update();
      // }, 1000);
    })

    self.el.find('.load-more').click(function (event) {
      event.preventDefault()

      if (!$(this).hasClass('loading')) {
        // decide what tab to render results in
        const tab = $(this).parents('.deal-container').attr('data-deal')
        const offset = parseInt(self.el.find('.tab[data-deal="' + tab + '"]').attr('data-offset'))
        self.showDeals(tab, offset)
      }

      $(this).addClass('loading')
    })
  }
}
